import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CustomRouter, View } from '@lib/core';

import { BasketService } from '@lib/shared/basket-service';
import { CatalogType } from '@lib/catalog/product-tree-filter/ui';
import {
    Basket,
    BasketItem,
    BasketItemRequest,
    SupplierBasket,
} from '@lib/basket/suppliers-basket/basket-supplier/basket-supplier-item/ui';

@Component({
    selector: 'basket-sidenav',
    templateUrl: './basket-sidenav.component.html',
    styleUrls: ['./basket-sidenav.component.scss'],
    standalone: false
})
export class BasketSideNavComponent {
    private readonly router = inject(CustomRouter);
    readonly basketService = inject(BasketService);

    @Input() supplierBaskets: SupplierBasket[] = [];
    @Input() basket!: Basket;
    @Output() basketItemDeleted = new EventEmitter<BasketItemRequest>();

    catalogType = CatalogType;

    navigateToBasket(): void {
        this.router.navigate([View.CLIENT, 'basket']);
        this.basketService.closeBasketSideNav();
    }

    deleteItem(item: BasketItem, supplierBasketId: string) {
        this.basketItemDeleted.emit({
            basketItem: item,
            supplierBasketId,
        });
    }
}
